// 사용법:
// <NoData />
// <NoData message={t('결재 대기 문서가 없습니다.')} />
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Txt from './Txt';

const NoData = ({ message = null, className = '', ...rest }) => {
	const { t } = useTranslation();

	return (
		<div className={`nodata_box ${className}`.trim()} {...rest}>
			<Txt color='gray'>{message ?? t('데이터가 없습니다.')}</Txt>
		</div>
	);
};

NoData.propTypes = {
	/**
	 * 표시할 문구 (없으면 '데이터가 없습니다.')
	 */
	message: PropTypes.node,
	className: PropTypes.string,
};

NoData.displayName = 'NoData';

export default NoData;